import { FALLBACK_MENU } from '@/utils/menu'
import { resolveMenuIconKey, GROUP_ICON, MODULE_ICON_BY_CODE } from '@/utils/menuIcons'

export const SIDEBAR_THEMES = {
  purple: { color: '#5b21b6', headerBg: '#f5f3ff' },
  green: { color: '#15803d', headerBg: '#f0fdf4' },
  orange: { color: '#c2410c', headerBg: '#fff7ed' },
  violet: { color: '#6d28d9', headerBg: '#f5f3ff' },
  cyan: { color: '#0e7490', headerBg: '#ecfeff' },
  gold: { color: '#b45309', headerBg: '#fffbeb' },
  blue: { color: '#1d4ed8', headerBg: '#eff6ff' },
  pink: { color: '#be185d', headerBg: '#fdf2f8' },
  indigo: { color: '#4338ca', headerBg: '#eef2ff' }
}

const MODULE_THEME_BY_CODE = {
  'module:overview': 'purple',
  'module:customer-mgmt': 'green',
  'module:sales-mgmt': 'orange',
  'module:material-mgmt': 'violet',
  'module:project-mgmt': 'cyan',
  'module:receivable-mgmt': 'gold',
  'module:cost-mgmt': 'gold',
  'module:analysis-mgmt': 'indigo',
  'module:ops-mgmt': 'pink',
  'module:system-mgmt': 'blue'
}

const GROUP_THEME = {
  客户管理: 'green',
  销售管理: 'orange',
  物料库存: 'violet',
  项目交付: 'cyan',
  收款管理: 'gold',
  成本付款: 'gold',
  经营分析: 'indigo',
  运营协同: 'pink',
  系统设置: 'blue'
}

function visibleKeys(nav) {
  return new Set(nav.filter((m) => !m.group).map((m) => m.key))
}

function toMenuItem(m) {
  const key = m.key
  return {
    key,
    text: m.text || m.name,
    iconKey: resolveMenuIconKey(key),
    path: m.path || `/${key}`
  }
}

function fromApiModules(modules, nav) {
  const keys = visibleKeys(nav)
  return modules
    .map((mod) => {
      const menus = (mod.menus || [])
        .filter((m) => keys.has(m.key))
        .map((m) => toMenuItem({ key: m.key, text: m.name, path: m.path }))
      if (!menus.length) return null
      const code = mod.code || mod.name
      const theme = MODULE_THEME_BY_CODE[code] || 'blue'
      const standalone = code === 'module:overview' && menus.length === 1
      return {
        code,
        name: mod.name,
        iconKey: standalone ? 'dashboard' : (MODULE_ICON_BY_CODE[code] || GROUP_ICON[mod.name] || 'doc'),
        theme,
        standalone,
        menus
      }
    })
    .filter(Boolean)
}

function fromFlatNav(nav) {
  const keys = visibleKeys(nav)
  const modules = []
  let current = null

  nav.forEach((item) => {
    if (item.group) {
      if (current && current.menus.length) modules.push(current)
      current = {
        code: item.group,
        name: item.group,
        iconKey: GROUP_ICON[item.group] || 'doc',
        theme: GROUP_THEME[item.group] || 'blue',
        standalone: false,
        menus: []
      }
      return
    }
    if (!keys.has(item.key)) return
    const menu = toMenuItem(item)
    if (item.key === 'dashboard' && !current) {
      modules.push({
        code: 'module:overview',
        name: '概览',
        iconKey: 'dashboard',
        theme: 'purple',
        standalone: true,
        menus: [{ ...menu, text: '经营驾驶舱' }]
      })
      return
    }
    if (!current) {
      current = {
        code: 'other',
        name: '菜单',
        iconKey: 'doc',
        theme: 'blue',
        standalone: false,
        menus: []
      }
    }
    current.menus.push(menu)
  })
  if (current && current.menus.length) modules.push(current)
  return modules
}

export function buildSidebarModules(menuModules, visibleMenus) {
  const nav = visibleMenus && visibleMenus.length ? visibleMenus : FALLBACK_MENU
  if (menuModules && menuModules.length) {
    const built = fromApiModules(menuModules, nav)
    if (built.length) return built
  }
  return fromFlatNav(nav)
}
